import React from 'react';
import ViewEmail from '../../compositions/EmailsOverview/ViewEmail';

const ViewEmailPage: React.FC = () => {
    return <ViewEmail />;
};

export default ViewEmailPage;
